
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Swal from 'sweetalert2'
import { auth } from '../../apiConstants';
import { Modal } from '../../useStyles';
import Loader from '../Loader';
import * as PageUrl from '../../utils/pageUrl'

export default function VerifyEmail() {
  const { payload } = useSelector(state => state.getAuthUser)
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)

  const sendToken = () => {
    setIsLoading(true)
    const token = sessionStorage.getItem("jwtToken");
    const bearerToken = "Bearer " + token;

    fetch(auth("verify-user"), {
      method: "GET",
      credentials: "same-origin",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearerToken,
      }),
    })
      .then((res) => res.json())
      .then(res => {
        setIsLoading(false)
        Swal.fire({
          title: res.message,
          text: "A token has been sent to your email.",
          icon: 'success',
          confirmButtonText: 'Enter Token',
          // denyButtonText: `Don't save`,
        }).then((result) => {

          if (result.isConfirmed) {
            // sessionStorage.clear()
            history.push(PageUrl.VERIFY_EMAIL)
          }
        })
      })
      .catch(err => {
        setIsLoading(false)
        Swal.fire({
          title: err.error,
          text: err.message,
          icon: 'error',
        })
      })
  }
  if (payload.user && !payload.user.verified) {
    return (
      <div>
        <Verify className='flex justify-between items-center'>
          <p>Verify your email to complete transactions</p>
          <button onClick={sendToken}>Verify</button>
        </Verify>

        {
          isLoading &&
          <Modal className="grid h-screen place-items-center" >
            <Loader />
          </Modal>
        }
      </div>
    )
  }
  else {
    return (<></>)
  }
}

const Verify = styled.div`
  color: #ab840a;
  background-color: #fef7e2;
  border-color: #fcebb7;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
  button{
    color: #fff;
    background-color: #f4bd0e;
    border-color: #f4bd0e;
    padding: 6px 1rem;
    border-radius: 4px;
  }
`;